import api from "@/lib/api";

const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

const loadScript = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
  const s = existing || document.createElement("script");
  s.addEventListener("load", () => resolve());
  s.addEventListener("error", () => reject(new Error("Could not load payment window. Check your connection.")));
  if (!existing) { s.src = SCRIPT_SRC; document.body.appendChild(s); }
});

// Resolves "paid" | "dismissed" | "failed"; throws on setup errors.
export async function payForBooking(bookingId) {
  await loadScript();
  const { data: o } = await api.post("/payments/razorpay/order", { booking_id: bookingId });
  return new Promise((resolve) => {
    let failed = false;
    const rzp = new window.Razorpay({
      key: o.key_id,
      amount: o.amount,
      currency: o.currency,
      order_id: o.order_id,
      name: "CelebrAI",
      description: `Booking ${bookingId}`,
      prefill: { ...o.prefill, contact: /^\d{10}$/.test(o.prefill?.contact || "") ? `+91${o.prefill.contact}` : o.prefill?.contact },
      theme: { color: "#E11D48" },
      handler: async (res) => {
        try {
          await api.post("/payments/razorpay/verify", { booking_id: bookingId, ...res });
          resolve("paid");
        } catch {
          resolve("failed");
        }
      },
      modal: { ondismiss: () => resolve(failed ? "failed" : "dismissed") },
    });
    rzp.on("payment.failed", (resp) => {
      failed = true;
      api.post("/payments/razorpay/failed", { booking_id: bookingId, reason: resp?.error?.description || "" }).catch(() => {});
    });
    rzp.open();
  });
}
